import {
  AfterContentInit,
  Component,
  ElementRef,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { FrontHeader } from '@app/src/app/components/front-header/front-header';
import {
  PROVIDER_NAMES,
  RenderHtml,
  Translation,
} from '@ckmk/angular';
import { ServicesHomeContainer } from '@app/src/app/modules/service/components/services-home-container/services-home-container';
import { SolutionsHomeContainer } from '@app/src/app/modules/solution/components/solutions-home-container/solutions-home-container';

@Component({
  selector: 'home',
  standalone: true,
  imports: [
    FrontHeader,
    Translation,
    RenderHtml,
    ServicesHomeContainer,
    SolutionsHomeContainer,
  ],
  templateUrl: './home.html',
  styleUrl: './home.scss',
  encapsulation: ViewEncapsulation.None,
})
export class Home implements OnInit, OnChanges, OnDestroy, AfterContentInit {
  protected readonly self = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly icons = inject(PROVIDER_NAMES.ICONS);

  public constructor() {}

  public ngOnInit() {}

  public ngOnChanges(changes: SimpleChanges) {}

  public ngOnDestroy() {}

  public ngAfterContentInit() {}
}
